import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {

    const {inputProps, arbitrageMessages, onChangeText, onConfirm, onCancel} = props;

    return (
        <SweetAlert
            show={inputProps.show}
            type={inputProps.type}
            confirmBtnCssClass="alert-btn-confirm"
            cancelBtnCssClass="alert-btn-cancel"
            showCancel
            showConfirm={inputProps.type === 'default' ? true : false}
            confirmBtnText="Отправить"
            cancelBtnText={inputProps.type === 'default' ? "Отменить" : "Закрыть"}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title="Арбитраж"
            onConfirm={() => onConfirm()}
            onCancel={() => onCancel()}
        >
            {
                inputProps.type === 'default'
                ?
                <div className="sw-alert__body">
                    <div>{inputProps.text}</div>
                    <textarea
                        onChange={(e) => onChangeText(e)}
                        className="arbitrage__textarea" value={inputProps.complaint}>
                    </textarea>
                    <span className="input-error-text">{inputProps.error}</span>
                    <span className="arbitrage__max-symbols">
                        {inputProps.maxSymbols - inputProps.complaint.length} символов
                    </span>
                </div>
                :
                <div className="sw-alert__body">{arbitrageMessages.sended}</div>
            }
        </SweetAlert>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/ArbitrageModal.js